import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SegmentInformationFormComponent } from '../segment-information-form/segment-information-form.component';
import {
  SegmentInformationTipsCardComponent,
  ICardTips,
} from '../segment-information-tips-card/segment-information-tips-card.component';
import { SegmentService } from '../../../../services/segments/segment-service.service';

/** Step 1 of the segment builder: the form, with guidance beside it. */
@Component({
  selector: 'segment-information',
  standalone: true,
  imports: [SegmentInformationFormComponent, SegmentInformationTipsCardComponent],
  templateUrl: './segment-information.component.html',
  styleUrls: ['../segment-builder.css', './segment-information.component.css'],
})
export class SegmentInformationComponent {
  @Input() editViewType = false;
  segmentService = inject(SegmentService);
  private router = inject(Router);

  /** Editing a saved segment offers no copy-from step, so its tip is left out. */
  visibleTips: ICardTips[] = [];

  ngOnInit() {
    const editing = this.router.url.includes('/segmented-list/edit');
    this.visibleTips = editing ? this.tips.slice(0, 2) : this.tips;
  }

  tips: ICardTips[] = [
    {
      title: 'Name',
      description: 'What people will look for when they pick an audience, such as “Gaborone women 25 to 40”.',
    },
    {
      title: 'Description',
      description: 'Who the segment is for and when to use it. It shows at the top of the segment’s page.',
    },
    {
      title: 'Start from an existing segment',
      description: 'Copies another segment’s conditions so you can adjust them. The original stays as it is.',
    },
  ];
}
